// import account from 'account';

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "context/useAuth";

// import ModelDepositTerms from './AccountComponents/ModalDepositTerms';
// import HeaderLoggedOut from 'components/HeaderLoggedOut';
// import HeaderMobileButton from 'components/HeaderMobileButton';
// import PagePreloader from 'components/PagePreloader';
// import ModalDepositExitConfirmation from './AccountComponents/ModalDepositExitConfirmation';
import HoldingsTab from "./AccountComponents/tabs/HoldingsTab";
import DepositTab from "./AccountComponents/tabs/DepositTab";
import DepositTabCad from "./AccountComponents/tabs/DepositTabCad";
import LeaderboardTab from "./AccountComponents/tabs/LeaderboardTab";
import WithdrawTab from "./AccountComponents/tabs/WithdrawTab";
import BalanceHistoryTab from "./AccountComponents/tabs/BalanceHistoryTab";
import ProfileTab from "./AccountComponents/tabs/ProfileTab";
import PreferencesTab from "./AccountComponents/tabs/PreferencesTab";
import NotificationsTab from "./AccountComponents/tabs/NotificationsTab";
import AdminBalanceTab from "./AccountComponents/tabs/AdminBalanceTab";
import AdminWithdrawalsTab from "./AccountComponents/tabs/AdminWithdrawalsTab";
import AdminLimitsTab from "./AccountComponents/tabs/AdminLimitsTab";
// import HeaderLoggedIn from 'components/HeaderLoggedIn';
import modals from "../components/modals";
import NavBarTab from "./AccountComponents/NavBarTab";

const AccountPage = () => {
  const { user, logout, loading } = useAuth();
  const navigate = useNavigate();

  const [showModalLogoutConfirmation, setShowModalLogoutConfirmation] =
    useState(false);

  const [activeTab, setActiveTab] = useState("holdings");

  useEffect(() => {
    console.log("AccountPage user:", user);
    if (!loading && !user) {
      navigate("/login");
    }
  }, [user, loading, navigate]);

  //   if (loading) return <div>Loading...</div>;
  if (loading) return null;
  if (!user) return null;

  // Real-currency (CAD) accounts get Deposit + Withdraw tabs; credits accounts
  // get Buy Credits + Leaderboard.
  const isReal = user.account_type === "real";
  const isAdmin = user.email?.trim().toLowerCase() === "admin";
  const displayedTab = isAdmin
    ? ["admin-balance", "admin-withdrawals", "admin-limits"].includes(activeTab)
      ? activeTab
      : "admin-balance"
    : (isReal && activeTab === "leaderboard") ||
        (!isReal && activeTab === "withdraw")
      ? "holdings"
      : activeTab;

  // const {
  //     user_id,
  //     email,
  //     creation_timestamp,
  //     referred_by,
  //     is_email_verified,
  //     balance,
  // } = user;

  // function setDepositTab() {
  //     console.log("section-deposit-button clicked");

  //     // if the deposit tab is not active, then set it up
  //     if (!document.getElementById("deposit-tab").classList.contains('active')) {
  //         // document.getElementById("deposit-select-solana").click();
  //     }
  // }

  const handleModalClose = (answer) => {
    setShowModalLogoutConfirmation(false);
    console.log("User answered:", answer);
    // Do something with `answer` (true/false)
    // if true, logout the user
    if (answer) {
      logout();
    }
  };

  return (
    <>
      {/* <link rel="stylesheet" href="/assets/css/style.min.css" />
    <link rel="stylesheet" href="style-general.css" />
    <link rel="stylesheet" href="style-terms.css" />
    <link rel="stylesheet" href="style-transaction-details.css" /> */}
      {/* <!-- <link rel="stylesheet" href="style-nice-select-adjustments.css"> --> */}
      {/* <style>
        #deposit-instructions-div * {
            margin-bottom: 10px;
        }
        #deposit-instructions-div input, #deposit-instructions-div span {
            font-weight: bold;
        }
    </style> */}

      {/* <PagePreloader /> */}

      <div id="alert" className="d-none" role="alert"></div>

      <modals.Logout
        show={showModalLogoutConfirmation}
        onClose={handleModalClose}
      />

      {/* {user ? <HeaderLoggedIn /> : <HeaderLoggedOut />} */}

      {/* <ModalLogout />
    <ModalDepositExitConfirmation />
    <ModalWithdrawConfirmation />
    <ModelDepositTerms />
    <ModelWithdrawTerms />
    
    <HeaderLoggedIn />
    <HeaderMobileButton /> */}

      <section className="pay_method pb-120">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 gx-0 gx-sm-4">
              <div
                className="hero_area__main"
                style={{ marginTop: 40, paddingTop: 0 }}
              >
                <div className="row gy-6 gy-xxl-0 singletab">
                  <div className="col-xxl-3">
                    <div className="pay_method__scrol">
                      <ul className="pay_method__scrollbar account-tabs-selector p2-bg p-5 p-md-6 rounded-4 d-flex align-items-center justify-content-center flex-xxl-column gap-3 gap-xxl-2">
                        {isAdmin ? (
                          <>
                            <NavBarTab
                              text="Change balances"
                              icon="ti-wallet"
                              onClick={() => setActiveTab("admin-balance")}
                              isActive={displayedTab === "admin-balance"}
                            />
                            <NavBarTab
                              text="Withdrawals"
                              icon="ti-credit-card"
                              onClick={() => setActiveTab("admin-withdrawals")}
                              isActive={displayedTab === "admin-withdrawals"}
                            />
                            <NavBarTab
                              text="Limits"
                              icon="ti-adjustments"
                              onClick={() => setActiveTab("admin-limits")}
                              isActive={displayedTab === "admin-limits"}
                            />
                          </>
                        ) : (
                          <>
                            <NavBarTab
                              text="Holdings"
                              icon="ti-garden-cart"
                              onClick={() => setActiveTab("holdings")}
                              isActive={displayedTab === "holdings"}
                            />
                            {isReal ? (
                              <>
                                <NavBarTab
                                  text="Deposit"
                                  icon="ti-wallet"
                                  onClick={() => setActiveTab("deposit")}
                                  isActive={displayedTab === "deposit"}
                                />
                                <NavBarTab
                                  text="Withdraw"
                                  icon="ti-credit-card"
                                  onClick={() => setActiveTab("withdraw")}
                                  isActive={displayedTab === "withdraw"}
                                />
                              </>
                            ) : (
                              <>
                                <NavBarTab
                                  text="Buy Credits"
                                  icon="ti-wallet"
                                  onClick={() => setActiveTab("deposit")}
                                  isActive={displayedTab === "deposit"}
                                />
                                <NavBarTab
                                  text="Leaderboard"
                                  icon="ti-crown"
                                  onClick={() => setActiveTab("leaderboard")}
                                  isActive={displayedTab === "leaderboard"}
                                />
                              </>
                            )}
                            <NavBarTab
                              text="Balance History"
                              icon="ti-history"
                              onClick={() => setActiveTab("balance-history")}
                              isActive={displayedTab === "balance-history"}
                            />
                            <NavBarTab
                              text="Profile"
                              icon="ti-user"
                              onClick={() => setActiveTab("profile")}
                              isActive={displayedTab === "profile"}
                            />
                            <NavBarTab
                              text="Preferences"
                              icon="ti-settings"
                              onClick={() => setActiveTab("preferences")}
                              isActive={displayedTab === "preferences"}
                            />
                            <NavBarTab
                              text="Notifications"
                              icon="ti-bell-ringing"
                              onClick={() => setActiveTab("notifications")}
                              isActive={displayedTab === "notifications"}
                            />
                          </>
                        )}
                        <li
                          onClick={() => setShowModalLogoutConfirmation(true)}
                          className="p-3 rounded-3 cpoint d-inline-block"
                          style={{ backgroundColor: "rgba(139, 0, 0, 0.5)" }}
                        >
                          <button className="d-flex align-items-center gap-2">
                            <i className={`ti ti-logout fs-five n5-color`}></i>
                            <span className="text-nowrap">Log out</span>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-xxl-9">
                    <div className="tabcontents">
                      {isAdmin && displayedTab === "admin-balance" && (
                        <AdminBalanceTab />
                      )}
                      {isAdmin && displayedTab === "admin-withdrawals" && (
                        <AdminWithdrawalsTab />
                      )}
                      {isAdmin && displayedTab === "admin-limits" && (
                        <AdminLimitsTab />
                      )}
                      {!isAdmin && (
                        <>
                          {displayedTab === "holdings" && <HoldingsTab />}
                          {displayedTab === "deposit" &&
                            (isReal ? <DepositTabCad /> : <DepositTab />)}
                          {displayedTab === "withdraw" && isReal && (
                            <WithdrawTab setActiveTab={setActiveTab} />
                          )}
                          {displayedTab === "leaderboard" && !isReal && (
                            <LeaderboardTab />
                          )}
                          {displayedTab === "balance-history" && (
                            <BalanceHistoryTab />
                          )}
                          {displayedTab === "profile" && <ProfileTab />}
                          {displayedTab === "preferences" && <PreferencesTab />}
                          {displayedTab === "notifications" && (
                            <NotificationsTab />
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <script src="/assets/js/plugins/plugins.js"></script>
    <script src="/assets/js/plugins/plugin-custom.js"></script>
    <script src="/assets/js/main.js"></script>

    <script src="script.js"></script>
    <script src="/assets/js/qrcode.min.js"></script>

    <script src="deposit-withdraw-utils.js"></script>
    <script src="deposit.js"></script>
    <script src="withdraw.js"></script>
    <script src="order-history.js"></script>
    <script src="tx-history.js"></script> */}
      {/* <script src="account.js"></script> */}
    </>
  );
};

export default AccountPage;
